import axios from 'axios';

export const getUserLicensesWithAttributes = (
  ssoToken: string,
  corpAcctNbr: string,
) =>
  axios.get(
    '/rest-api/iam/v2/users/current/licenses?includeFeatureAttributes=true',
    {
      headers: {
        'Content-Type': 'application/json',
        'nextiva-context-corpAcctNumber': String(corpAcctNbr),
        Authorization: `Bearer ${ssoToken}`,
      },
      withCredentials: true,
    },
  );
